import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalType } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { DisplayComponent } from '@app/shared/components/display/display.component';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-magicbag-info-modal',
  templateUrl: './magicbag-info.component.html',
  styleUrls: ['./magicbag-info.component.scss'],
  standalone: true,
  imports: [NavigationButtonComponent, DisplayComponent, SharedModule],
})
export class MagicBagInfoModalComponent {
  magicBagInfoModalData = inject<Modal>(MAT_DIALOG_DATA);

  private readonly eventManager = inject(EventManager);

  closeModal(): void {
    this.eventManager.closeModal(new Modal(this.magicBagInfoModalData.id, ModalType.View, this.magicBagInfoModalData));
  }
}
